import apiClient from './apiClient';

export const goalsApi = {
  // Get all goal types
  getGoalTypes: () => apiClient.get('/goals/types'),

  // Create a new goal
  createGoal: (goalData) => apiClient.post('/goals/create', goalData),

  // Get user's goals
  getUserGoals: (params = {}) => apiClient.get('/goals', { params }),

  // Get specific goal details
  getGoalDetails: (goalId, params = {}) => apiClient.get(`/goals/${goalId}`, { params }),

  // Contribute to a goal
  contributeToGoal: (goalId, contribution) => apiClient.post(`/goals/${goalId}/contribute`, contribution),

  // Update goal
  updateGoal: (goalId, goalData) => apiClient.put(`/goals/${goalId}`, goalData),

  // Delete goal
  deleteGoal: (goalId) => apiClient.delete(`/goals/${goalId}`),

  // Get goal-specific content
  getGoalContent: (goalId) => apiClient.get(`/goals/${goalId}/content`),

  // Mark content as viewed
  markContentViewed: (contentId, goalId, viewData) => apiClient.post(`/goals/content/${contentId}/view/${goalId}`, viewData),

  // Get user badges
  getUserBadges: (params = {}) => apiClient.get('/goals/badges', { params }),

  // Get goal analytics
  getGoalAnalytics: (goalId, period = 'monthly') => apiClient.get(`/goals/${goalId}/analytics`, { params: { period } }),
};

export default goalsApi;
